import Footer from "../components/Footer";
import Header from "../components/Header";
import AllExclusiveHero from "../components/Vacation-hero/AllExclusiveHero";
import SearchBar from "../components/SearchBar";
import Breadcrumbs from "../components/BreadcrumbsComponent";

interface Props {
  children: React.ReactNode;
}

const LayoutAllInclusive = ({ children }: Props) => {
  return (
  <div className="flex flex-col min-h-screen">
      <Header />
      {/* Apply min-h-screen to make this section take up at least the height of the viewport */}
      <section className="">
        <AllExclusiveHero />
        <div className="container mx-auto pt-2 px-8">
          <Breadcrumbs />
        </div>
        <div className="container mx-auto px-5 -mt-20">
          {/* {showSearchBar && <SearchBar />} */}
           <SearchBar />
        </div>
      </section>
      <div className="container mx-auto py-10 flex-1">{children}</div>
      <Footer />
    </div>
  );
};

export default LayoutAllInclusive;
